import MiniAppEvents from 'src/helpers/miniapp-events';
import { prettyPrintTealiumEvent } from './tealium-debug';
import { Environment } from 'src/Environment';

interface CustomWindow extends Window {
  utag?: any;
}

class Tealium {
  _queue: { (): void }[] = [];
  _initialized = false;
  _frequency = 100;
  _timeout = 2000 * this._frequency; // 2 seconds * frequency (milliseconds);
  debug =
    Environment.current?.allowDevTools && !Environment.current?.disabledFeatures?.debugtagging;
  disable = Environment.current?.allowDevTools && Environment.current?.disabledFeatures?.analytics;

  constructor() {
    if (!this.disable) {
      this._run();
    }
  }

  _run() {
    window.setTimeout(() => {
      if ('utag' in window) {
        this._initialized = true;
        this._timeout = 0;

        this._process();
      }

      this._timeout -= this._frequency;

      if (this._timeout > 0) {
        this._run();
      }
    }, this._frequency);
  }

  // Process queue
  _process() {
    if (!this._initialized) {
      return;
    }

    let action;

    action = this._queue.shift();

    while (action) {
      action();
      action = this._queue.shift();
    }
  }

  // Send view event
  view(data) {
    if (MiniAppEvents.isInMiniApp()) {
      data.page_type = 'webview';
      data.page_channel = 'mobile app';
    }

    if (this.debug) {
      prettyPrintTealiumEvent(data);
      return;
    }

    this._queue.push(() => {
      (window as CustomWindow).utag.view(data);
    });
    this._process();
  }

  // Send link event
  link(data) {
    if (!!data.link_name) {
      data.link_id = data.link_name;
    }

    if (MiniAppEvents.isInMiniApp()) {
      data.page_type = 'webview';
      data.page_channel = 'mobile app';
    }

    if (this.debug) {
      prettyPrintTealiumEvent(data);
      return;
    }

    this._queue.push(() => {
      (window as CustomWindow).utag.link(data);
    });

    this._process();
  }
}

const objTealium = new Tealium();

export default objTealium;
